// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2025-11-13T17:17:07.089Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const CustomerListView = lazy(() => import('@/sales/CustomerListView').then(m => ({ default: m.CustomerListView })));
const CustomerDetailView = lazy(() => import('@/sales/CustomerDetailView').then(m => ({ default: m.CustomerDetailView })));
const CustomerGroupListView = lazy(() => import('@/sales/CustomerGroupListView').then(m => ({ default: m.CustomerGroupListView })));
const CustomerGroupDetailView = lazy(() => import('@/sales/CustomerGroupDetailView').then(m => ({ default: m.CustomerGroupDetailView })));
const InvoiceListView = lazy(() => import('@/sales/InvoiceListView').then(m => ({ default: m.InvoiceListView })));
const InvoiceDetailView = lazy(() => import('@/sales/InvoiceDetailView').then(m => ({ default: m.InvoiceDetailView })));
const OrderListView = lazy(() => import('@/sales/OrderListView').then(m => ({ default: m.OrderListView })));
const OrderDetailView = lazy(() => import('@/sales/OrderDetailView').then(m => ({ default: m.OrderDetailView })));

/**
 * Sales Module Routes
 */
export const salesRoutes = [
{ path: '/sales/customers',
element: <Suspense><CustomerListView /></Suspense> },
{ path: '/sales/customers/:id',
element: <Suspense><CustomerDetailView /></Suspense> },
{ path: '/sales/customers/template/new',
element: <Suspense><CustomerDetailView mode="template" /></Suspense> },
{ path: '/sales/customers/template/:templateId',
element: <Suspense><CustomerDetailView mode="template" /></Suspense> },
{ path: '/sales/customergroups',
element: <Suspense><CustomerGroupListView /></Suspense> },
{ path: '/sales/customergroups/:id',
element: <Suspense><CustomerGroupDetailView /></Suspense> },
{ path: '/sales/invoices',
element: <Suspense><InvoiceListView /></Suspense> },
{ path: '/sales/invoices/:id',
element: <Suspense><InvoiceDetailView /></Suspense> },
{ path: '/sales/orders',
element: <Suspense><OrderListView /></Suspense> },
{ path: '/sales/orders/:id',
element: <Suspense><OrderDetailView /></Suspense> },
{ path: '/sales/orders/template/new',
element: <Suspense><OrderDetailView mode="template" /></Suspense> },
{ path: '/sales/orders/template/:templateId',
element: <Suspense><OrderDetailView mode="template" /></Suspense> }
];
